import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { faArrowRight, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { Subject, Subscription } from 'rxjs';
import { ISiteIntervention } from '../../entities/interventions/site-intervention.interface';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SitesInterventionReadService } from '../../services/sites-intervention.read.service';
import { OfflineNotificationService } from '../../services/offline-notification.service';

@Component({
  selector: 'in2-site-selecteur',
  templateUrl: 'site-selecteur.component.html',
  styleUrls: ['./site-selecteur.component.scss'],
  standalone: false,
})
export class SiteSelecteurComponent implements OnInit, OnDestroy {
  public faArrowRight = faArrowRight;
  public faChevronRight = faChevronRight;

  public readonly isLoading = signal(false);
  public queryText = '';
  public readonly sitesResult = signal<ISiteIntervention[]>([]);

  @Output() public siteSelected: EventEmitter<ISiteIntervention> = new EventEmitter<ISiteIntervention>();
  @Input() public title = '';
  @Input() public speech?: string;
  @Input() public withSeculib: boolean = true;

  private queryTextChanged: Subject<string> = new Subject<string>();
  private queryTextChangedSubscription?: Subscription;

  constructor(
    private readonly sitesInterventionReadService: SitesInterventionReadService,
    private readonly offlineNotificationService: OfflineNotificationService
  ) {}

  public ngOnDestroy() {
    this.queryTextChangedSubscription?.unsubscribe();
  }

  public ngOnInit() {
    this.queryTextChangedSubscription = this.queryTextChanged.pipe(debounceTime(500), distinctUntilChanged()).subscribe(newText => {
      try {
        this.sitesResult.set([]);
        this.isLoading.set(true);
        this.sitesInterventionReadService.fetch({ query: newText, withSeculib: this.withSeculib }).subscribe(res => {
          this.sitesResult.set(res);
          this.isLoading.set(false);
        });
      } catch (error) {
        if (this.offlineNotificationService.isOffline()) {
          this.isLoading.set(false);
        }
      }
    });
  }

  public onQueryChange(e: any): void {
    this.queryTextChanged.next(e);
  }

  public chooseSite(site: ISiteIntervention) {
    this.siteSelected.next(site);
  }
}
